import type { BaseAppError } from '@modules/core/errors';
import type { ISettingBookkeepingDeletePayload } from '@modules/general-settings/submodules/bookkeeping/types';
import { useRestClient } from '@modules/core/services/api';
import { useContextMutation } from '@modules/core/services/query';
import {
  ADMIN_GENERAL_SETTINGS_BOOKKEEPING_PERMISSIONS,
  SETTINGS_BOOKKEEPING_DELETE_QUERY_KEY,
  SETTINGS_BOOKKEEPING_DELETE_URL,
  SETTINGS_BOOKKEEPING_LIST_QUERY_KEY,
  SETTINGS_BOOKKEEPING_UPDATE_QUERY_KEY,
} from '@modules/general-settings/submodules/bookkeeping/constants';
import { useToastStore } from '@modules/toast/store';

export default function useSettingsBookkeepingDeleteMutation(): ReturnType<
  typeof useContextMutation<void, Error | BaseAppError, ISettingBookkeepingDeletePayload>
> {
  const { fetchDelete } = useRestClient();
  const { displayPresetToast } = useToastStore();

  return useContextMutation<
    void,
Error | BaseAppError,
ISettingBookkeepingDeletePayload
  >({
    mutationKey: [SETTINGS_BOOKKEEPING_UPDATE_QUERY_KEY],
    mutationFn: (payload) => fetchDelete(
      SETTINGS_BOOKKEEPING_DELETE_URL,
      {
        permission: ADMIN_GENERAL_SETTINGS_BOOKKEEPING_PERMISSIONS.HISTORYOFLIMITCHANGES_DELETE,
        urlParams: {
          id: payload.id,
        },
      },
    ),
    async onSuccess({ queryClient }) {
      await queryClient.invalidateQueries({ queryKey: [SETTINGS_BOOKKEEPING_DELETE_QUERY_KEY, SETTINGS_BOOKKEEPING_LIST_QUERY_KEY] });
      await queryClient.refetchQueries({ queryKey: [SETTINGS_BOOKKEEPING_LIST_QUERY_KEY] });
      displayPresetToast('edited');
    },
  });
}
